import colors from "@/enum/colors";
import store from "@/store/store";
import {computed} from "vue";

export default computed(() => {
    const { inCall, onHold } = store.getters['layout/colors']('activeLayout')

    return {
        1: {
            icon: "LogIn",
            color: colors.LOGIN_COLOR,
            text: 'status.login',
            value: 1
        },
        2: {
            icon: "LogOut",
            color: colors.LOGOUT_COLOR,
            text: 'status.logout',
            value: 2
        },
        3: {
            icon: "Utensils",
            color: colors.LUNCH_COLOR,
            text: 'status.lunch',
            value: 3
        },
        5: {
            icon: "Settings",
            color: colors.ADMINISTRATIVE_COLOR,
            text: 'status.administrative',
            value: 5
        },
        7: {
            icon: "IconLockKeyhole",
            color: colors.PRIVATE_COLOR,
            text: 'status.private',
            value: 7
        },
        9: {
            icon: "IconEllipsis",
            color: colors.OTHER_COLOR,
            text: 'status.other',
            value: 9
        },
        11: {
            icon: "GraduationCap",
            color: colors.TRAINING_COLOR,
            text: 'status.training',
            value: 11
        },
        12: {
            icon: "IconPresentation",
            color: colors.TEAM_MEETING_COLOR,
            text: 'status.teamMeeting',
            value: 12
        },
        13: {
            icon: "ClipboardList",
            color: colors.BRIEF_COLOR,
            text: 'status.brief',
            value: 13
        },
        100: {
            icon: 'PhoneIncoming',
            color: inCall,
            text: 'status.incall',
            value: 100
        },
        101: {
            icon: 'Pause',
            color: onHold,
            text: 'status.hold',
            value: 101
        },
        102: {
            icon: 'BriefCase',
            color: colors.LIGHT_GREEN,
            text: 'status.atWork',
            value: 102
        }
    }
})
